var React = require('react');

function CircleBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m264.72 292.86c50.68-33.78 64.92-101.14 31.22-150.67-35.33-53.61-102.05-62.19-148.34-32.05-54 35.22-67.28 98.66-35.2 149.51 33.19 52.6 101.2 67.28 152.32 33.21zm-130.04-45.86c-22.93-36.19-14.53-87.1 26.36-113.75 37.59-24.48 90.13-13.88 113.46 22.53 22.91 33.22 14.5 88.59-23.23 113.62-41.46 27.47-93.41 14.19-116.59-22.4z","fill":"#2a76b4"}));
}

CircleBlue.defaultProps = {"viewBox":"0 0 410 405"};

module.exports = CircleBlue;

CircleBlue.default = CircleBlue;
